import { mdsDashboardActions } from '../../actions/constant';

const { SET_MDS_WORKSHEET_DIRTY } = mdsDashboardActions;

const initialState = {
  dirty: false,
};

export const mdsWorksheetDirtyReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case SET_MDS_WORKSHEET_DIRTY:
      return {
        ...state,
        dirty: Boolean(action.payload),
      };

    default:
      return state;
  }
};
